import { apiModule } from './apiModule';
import { container } from 'src/StaticContainer';

/**
 * Side-effect import that loads the API instance bindings into the host's
 * static container. Import this exactly once per host entry, after the
 * `init/2-container*` import (window hosts get it through `init/3-prelude`;
 * worker entries import it directly).
 *
 * The guard tolerates hosts whose boot path evaluates this module more than
 * once against the same global container.
 *
 * This module MUST stay listed in projects/web/package.json `sideEffects`:
 * it is consumed as a bare import, so production tree-shaking deletes it
 * otherwise (loadApiModule.chunk.test.ts makes that unshippable).
 */
if (!container.isBound('PlatformApi')) {
    container.load(apiModule);
}
